import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["onChange", "value", "placeholder", "maxLength", "disabled"];
var _effectorFileName = "/builds/gmini/front-common/src/components/ComplexConditions/InputField.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { Tooltip } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InputField = /*#__PURE__*/React.memo(function (_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      disabled = _ref.disabled,
      other = _objectWithoutProperties(_ref, _excluded);

  var _useResizeDetector = useResizeDetector(),
      textWidth = _useResizeDetector.width,
      textRef = _useResizeDetector.ref;

  var _useResizeDetector2 = useResizeDetector(),
      inputWidth = _useResizeDetector2.width,
      inputRef = _useResizeDetector2.ref;

  var toolTipActive = textWidth && inputWidth && textWidth >= inputWidth;
  var classes = useStyles();
  var changeUnit = React.useCallback(function (e) {
    if (onChange) {
      onChange(e.target.value);
    }
  }, [onChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: toolTipActive ? /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        children: value
      }) : '',
      enterDelay: 500,
      enterNextDelay: 500,
      arrow: true,
      children: /*#__PURE__*/_jsx(TextField, _objectSpread({
        variant: "outlined",
        size: "small",
        placeholder: placeholder,
        className: classes.root,
        value: value,
        onChange: changeUnit,
        disabled: disabled,
        inputProps: {
          maxLength: maxLength ? maxLength : ''
        },
        inputRef: inputRef
      }, other))
    }), /*#__PURE__*/_jsx("span", {
      ref: textRef,
      style: {
        visibility: 'hidden',
        position: 'absolute',
        left: -9999,
        // шрифт должен быть идентичным шрифту инпута
        fontSize: '1rem',
        overflow: 'scroll'
      },
      children: value
    })]
  });
});
InputField.displayName = 'InputField';
var useStyles = makeStyles({
  root: {
    backgroundColor: '#fff',
    flexGrow: 1
  }
});